/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorReviewsConversationDetailsRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.reviews.conversation.details',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorReviewsConversationDetailsRoute);
